module.exports = __webpack_public_path__ + "static/vf_mpants_core.465bc3ee.svg";